import PersonalInformationForm from './PersonalInformationForm';
import InfoCard, { InfoRow } from '../../components/InfoCard';
import { EditIcon } from '../../../../../assets/icons/common';
import { useSelector } from '../../../../../store/store';
import { EMPTY_VALUE } from '../../constants';
import styles from './style.module.scss';
import { useState } from 'react';
import {
    selectProfileData,
    selectUserAttributes,
} from '../../../../../store/workspace/selectors';

/** Read-only view of the applicant's contact details, salary and visa answers. */
function PersonalInformation() {
    const profile = useSelector(selectProfileData);
    const user = useSelector(selectUserAttributes);
    const [isFormOpen, setIsFormOpen] = useState(false);

    return (
        <div className={styles.wrapper}>
            <InfoCard
                title='Personal information'
                actions={<EditIcon onClick={() => setIsFormOpen(true)} />}
            >
                <InfoRow label='Full name' value={<>{user?.given_name} {user?.family_name}</>} />
                <InfoRow label='Phone number' value={user?.phone_number} />
                <InfoRow label='Preferred name' value={user?.['custom:preferredName'] || EMPTY_VALUE} />
                <InfoRow label='Email' value={user?.email} />
                <InfoRow label='DOB' value={user?.birthdate} />
                <InfoRow label='City' value={user?.['custom:city'] || EMPTY_VALUE} />
                <InfoRow label='Country' value={user?.['custom:country'] || EMPTY_VALUE} />
                <InfoRow label='Address' value={user?.address} />
                <InfoRow label='Zip code' value={user?.['custom:zipCode'] || EMPTY_VALUE} />
                <InfoRow label='State' value={user?.['custom:state'] || EMPTY_VALUE} />
                <InfoRow label='LinkdIn link' value={user?.['custom:linkedinLink'] || EMPTY_VALUE} />
            </InfoCard>

            <InfoCard title='Salary & visa'>
                <InfoRow
                    label='Salary expectation'
                    value={profile?.desiredAnnualSalaryRange ? `${profile.desiredAnnualSalaryRange}$` : EMPTY_VALUE}
                />
                <InfoRow
                    label='e.g. H-1B visa status requirement'
                    value={profile?.requireSponsorshipVisa}
                />
            </InfoCard>

            {isFormOpen && <PersonalInformationForm onClose={() => setIsFormOpen(false)} />}
        </div>
    );
};

export default PersonalInformation;
